// AudioQuest RCA Cables landing page + RCA Cable Finder
// Product data is injected server-side by sections/audioquest-rca-landing.liquid as a
// <script type="application/json" data-aq-rca-products="<section id>"> block built from
// real Shopify products/variants — prices, lengths and Single/Pair options are never hardcoded.
(function () {
    // System level → ideal performance rank (ported from the original WordPress widget).
    var SYSTEM_TIER = { entry: 1.5, mid: 4.5, high: 8, reference: 11 };
    var SYSTEM_LABEL = { entry: 'entry-level', mid: 'mid-range', high: 'high-end', reference: 'reference' };
    var BUDGET_LABEL = { budget1: 'under $150', budget2: '$150–$300', budget3: '$300–$600', budget4: '$600+' };
    var TYPE_LABEL = { interconnect: 'Stereo interconnect', subwoofer: 'Subwoofer cable' };
    var TOTAL_STEPS = 4;

    // Budget is checked against the price of the exact variant the customer would buy.
    function fitsBudget(price, key) {
        if (key === 'budget1') return price < 150;
        if (key === 'budget2') return price <= 300;
        if (key === 'budget3') return price <= 600;
        return true;
    }

    function esc(value) {
        return String(value == null ? '' : value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    function money(value) {
        var num = parseFloat(value);
        if (isNaN(num)) return '—';
        return '$' + num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function metersLabel(m) {
        return (Math.round(m * 100) / 100) + ' m';
    }

    function prepareProduct(p) {
        p.type = p.type || 'interconnect';
        p.variants = (p.variants || []).map(function (v) {
            v.meters = parseFloat(v.length);
            if (isNaN(v.meters)) v.meters = 0;
            return v;
        });
        p.packs = [];
        p.variants.forEach(function (v) {
            if (v.pack && p.packs.indexOf(v.pack) === -1) p.packs.push(v.pack);
        });
        p.packs.sort(function (a, b) {
            // Pair first — a stereo connection needs left + right.
            return (/pair/i.test(a) ? 0 : 1) - (/pair/i.test(b) ? 0 : 1);
        });
        var prices = p.variants.map(function (v) { return v.price; });
        var meters = p.variants.map(function (v) { return v.meters; });
        p.minPrice = prices.length ? Math.min.apply(null, prices) : Infinity;
        p.minLength = meters.length ? Math.min.apply(null, meters) : 0;
        p.maxLength = meters.length ? Math.max.apply(null, meters) : 0;
        p.features = (p.features || []).filter(function (f) { return f && f.trim(); });
        return p;
    }

    function initAqRca(root) {
        if (!root || root.dataset.aqRcaInit === 'true') return;
        root.dataset.aqRcaInit = 'true';

        var sectionId = root.id.replace('aq-rca-', '');
        var dataEl = document.querySelector('[data-aq-rca-products="' + sectionId + '"]');
        var products = [];
        try {
            products = JSON.parse(dataEl ? dataEl.textContent : '[]');
        } catch (e) {
            products = [];
        }
        products = products.filter(function (p) { return p && p.productId; }).map(prepareProduct);

        var cartAddUrl = root.dataset.cartAddUrl || '/cart/add';

        var productsGrid = root.querySelector('[data-aq-products-grid]');
        var typeBtns = root.querySelectorAll('[data-aq-type-btn]');
        var tierBtns = root.querySelectorAll('[data-aq-tier-btn]');
        var faqQuestions = root.querySelectorAll('[data-aq-faq-question]');
        var modal = root.querySelector('[data-aq-modal]');
        var modalClose = root.querySelector('[data-aq-modal-close]');
        var modalHeader = root.querySelector('[data-aq-modal-header]');
        var modalBody = root.querySelector('[data-aq-modal-body]');

        var finder = root.querySelector('[data-aq-finder]');
        var finderFill = root.querySelector('[data-aq-finder-fill]');
        var finderDots = root.querySelectorAll('[data-aq-finder-dot]');
        var finderBody = root.querySelector('[data-aq-finder-body]');
        var finderBack = root.querySelector('[data-aq-finder-back]');
        var finderResults = root.querySelector('[data-aq-finder-results]');
        var finderResultsGrid = root.querySelector('[data-aq-finder-results-grid]');
        var finderSummary = root.querySelector('[data-aq-finder-summary]');
        var finderNotice = root.querySelector('[data-aq-finder-notice]');

        var answers = {};
        var currentStep = 1;
        var gridType = 'interconnect';
        var gridTier = 'all';

        function findProduct(id) {
            return products.filter(function (p) { return p.id === id; })[0] || null;
        }

        /* ── Variants ── */

        function variantsForPack(product, pack) {
            if (!product.packs.length || !pack) return product.variants;
            var list = product.variants.filter(function (v) { return v.pack === pack; });
            return list.length ? list : product.variants;
        }

        function defaultPack(product) {
            return product.packs[0] || '';
        }

        function closestVariant(list, targetMeters) {
            var best = null;
            list.forEach(function (v) {
                if (!best) { best = v; return; }
                var d = Math.abs(v.meters - targetMeters);
                var bestD = Math.abs(best.meters - targetMeters);
                if (d < bestD || (d === bestD && v.meters > best.meters)) best = v;
            });
            return best;
        }

        // The variant a customer needing `meters` would actually buy: the shortest length
        // that covers the run (cheapest if a length is listed twice), in the default pack.
        function variantForRun(product, meters) {
            var covering = variantsForPack(product, defaultPack(product))
                .filter(function (v) { return v.meters >= meters - 0.001; })
                .sort(function (a, b) { return (a.meters - b.meters) || (a.price - b.price); });
            return covering[0] || null;
        }

        function longestVariant(product) {
            return variantsForPack(product, defaultPack(product))
                .slice()
                .sort(function (a, b) { return b.meters - a.meters; })[0] || null;
        }

        /* ── Variant picker (shared by finder results and the details modal) ── */

        function lengthOptionsHtml(product, pack, selectedVariant) {
            var seen = [];
            return variantsForPack(product, pack)
                .slice()
                .sort(function (a, b) { return a.meters - b.meters; })
                .filter(function (v) {
                    if (seen.indexOf(v.length) !== -1) return false;
                    seen.push(v.length);
                    return true;
                })
                .map(function (v) {
                    var selected = selectedVariant && selectedVariant.length === v.length ? ' selected' : '';
                    return '<option value="' + esc(v.length) + '"' + selected + '>' + esc(metersLabel(v.meters)) + '</option>';
                }).join('');
        }

        function variantPickerHtml(product, variant) {
            var pack = (variant && variant.pack) || defaultPack(product);

            var packHtml = '';
            if (product.packs.length > 1) {
                packHtml =
                    '<label class="aq-vp-field">' +
                        '<span class="aq-vp-label">Sold As</span>' +
                        '<select class="aq-vp-select" data-aq-vp-pack>' +
                            product.packs.map(function (p) {
                                return '<option value="' + esc(p) + '"' + (p === pack ? ' selected' : '') + '>' + esc(p) + '</option>';
                            }).join('') +
                        '</select>' +
                    '</label>';
            }

            return (
                '<div class="aq-vp" data-aq-vp="' + esc(product.id) + '">' +
                    '<div class="aq-vp-fields">' +
                        '<label class="aq-vp-field">' +
                            '<span class="aq-vp-label">Length</span>' +
                            '<select class="aq-vp-select" data-aq-vp-length>' + lengthOptionsHtml(product, pack, variant) + '</select>' +
                        '</label>' +
                        packHtml +
                    '</div>' +
                    '<div class="aq-vp-price" data-aq-vp-price>—</div>' +
                    '<div class="aq-vp-actions">' +
                        '<form action="' + esc(cartAddUrl) + '" method="post" class="aq-vp-form">' +
                            '<input type="hidden" name="id" value="" data-aq-vp-variant-id>' +
                            '<input type="hidden" name="quantity" value="1">' +
                            '<button type="submit" class="aq-btn aq-btn-primary" data-aq-vp-buy>Add to Cart</button>' +
                        '</form>' +
                        '<a href="' + esc(product.url) + '" class="aq-btn aq-btn-secondary" data-aq-vp-view>View Product</a>' +
                    '</div>' +
                '</div>'
            );
        }

        function updateVariantPicker(vp) {
            var product = findProduct(vp.getAttribute('data-aq-vp'));
            if (!product) return;

            var packSelect = vp.querySelector('[data-aq-vp-pack]');
            var lengthSelect = vp.querySelector('[data-aq-vp-length]');
            var pack = packSelect ? packSelect.value : defaultPack(product);
            var length = lengthSelect ? lengthSelect.value : '';

            var variant = variantsForPack(product, pack).filter(function (v) { return v.length === length; })[0] || null;

            var priceEl = vp.querySelector('[data-aq-vp-price]');
            var idInput = vp.querySelector('[data-aq-vp-variant-id]');
            var buyBtn = vp.querySelector('[data-aq-vp-buy]');
            var viewBtn = vp.querySelector('[data-aq-vp-view]');

            if (priceEl) {
                priceEl.innerHTML = variant
                    ? money(variant.price) + (variant.pack ? ' <span class="aq-vp-price-note">/ ' + esc(variant.pack.toLowerCase()) + '</span>' : '')
                    : 'N/A';
            }
            if (idInput) idInput.value = variant ? variant.id : '';
            if (buyBtn) {
                var disabled = !variant || variant.available === false;
                buyBtn.disabled = disabled;
                buyBtn.classList.toggle('is-disabled', disabled);
                buyBtn.textContent = !variant ? 'Not Available' : (variant.available === false ? 'Currently Unavailable' : 'Add to Cart');
            }
            if (viewBtn) {
                viewBtn.setAttribute('href', variant ? product.url + '?variant=' + variant.id : product.url);
            }
        }

        function onPackChange(vp) {
            var product = findProduct(vp.getAttribute('data-aq-vp'));
            var packSelect = vp.querySelector('[data-aq-vp-pack]');
            var lengthSelect = vp.querySelector('[data-aq-vp-length]');
            if (!product || !packSelect || !lengthSelect) return;

            // Keep the chosen length if this pack offers it, otherwise the closest one.
            var currentMeters = parseFloat(lengthSelect.value) || 0;
            var variant = closestVariant(variantsForPack(product, packSelect.value), currentMeters);
            lengthSelect.innerHTML = lengthOptionsHtml(product, packSelect.value, variant);
            updateVariantPicker(vp);
        }

        /* ── Product grid ── */

        function updateTierButtons() {
            tierBtns.forEach(function (btn) {
                var tier = btn.dataset.aqTierBtn;
                var count = products.filter(function (p) {
                    return p.type === gridType && (tier === 'all' || p.tier === tier);
                }).length;
                btn.hidden = tier !== 'all' && count === 0;
                btn.classList.toggle('active', tier === gridTier);
            });
        }

        function renderProducts() {
            if (!productsGrid) return;
            var filtered = products.filter(function (p) {
                return p.type === gridType && (gridTier === 'all' || p.tier === gridTier);
            });

            if (!filtered.length) {
                productsGrid.innerHTML = '<p class="aq-empty-note">No cables in this category yet.</p>';
                return;
            }

            productsGrid.innerHTML = filtered.map(function (product) {
                var imageHtml = product.image
                    ? '<img src="' + esc(product.image) + '" alt="AudioQuest ' + esc(product.name) + ' ' + (product.type === 'subwoofer' ? 'Subwoofer' : 'RCA') + ' Cable" loading="lazy">'
                    : '';
                var conductorCode = (product.conductor.match(/\(([^)]+)\)/) || [])[1] || product.conductor.replace(/^Solid\s+/i, '');
                var features = product.features.slice(0, 4).map(function (f) {
                    return '<li>' + esc(f) + '</li>';
                }).join('');
                var lengthRange = product.variants.length
                    ? (Math.round(product.minLength * 100) / 100) + ' – ' + metersLabel(product.maxLength)
                    : '';

                return (
                    '<div class="aq-product-card' + (product.featured ? ' featured' : '') + '" data-product="' + esc(product.id) + '">' +
                        '<div class="aq-product-header">' +
                            '<span class="aq-product-tier-badge aq-tier-' + esc(product.tier) + '">' + esc(product.tierLabel) + '</span>' +
                            '<div class="aq-product-image' + (imageHtml ? '' : ' no-image') + '">' + imageHtml + '</div>' +
                            '<h3 class="aq-product-name">' + esc(product.name) + '</h3>' +
                            '<div class="aq-product-specs-mini">' +
                                '<span class="aq-spec-badge highlight">' + esc(conductorCode) + '</span>' +
                                (/72v/i.test(product.noise) ? '<span class="aq-spec-badge">72v DBS</span>' : (/carbon/i.test(product.noise) ? '<span class="aq-spec-badge">Carbon</span>' : '')) +
                                (lengthRange ? '<span class="aq-spec-badge">' + esc(lengthRange) + '</span>' : '') +
                            '</div>' +
                        '</div>' +
                        '<div class="aq-product-body">' +
                            '<ul class="aq-product-features">' + features + '</ul>' +
                            '<div class="aq-product-price">' +
                                '<div class="aq-price-from">Starting at</div>' +
                                '<div class="aq-price-value">' + money(product.minPrice) + '</div>' +
                            '</div>' +
                            '<div class="aq-product-cta">' +
                                '<button type="button" class="aq-btn aq-btn-primary" data-aq-show-details="' + esc(product.id) + '">Details &amp; Pricing</button>' +
                                '<a href="' + esc(product.url) + '" class="aq-btn aq-btn-secondary">View Product</a>' +
                            '</div>' +
                        '</div>' +
                    '</div>'
                );
            }).join('');
        }

        /* ── Details modal ── */

        function showProductDetails(productId) {
            var product = findProduct(productId);
            if (!product || !modal) return;

            if (modalHeader) {
                modalHeader.innerHTML =
                    '<h3 class="aq-modal-title">AudioQuest ' + esc(product.name) + '</h3>' +
                    '<p class="aq-modal-subtitle">' + esc(product.tierLabel) + ' Series • ' +
                        (product.type === 'subwoofer' ? 'RCA Subwoofer Cable' : 'RCA Analog Interconnect') + '</p>';
            }

            if (modalBody) {
                var specBox = function (label, value) {
                    return '<div class="aq-modal-spec-box"><div class="aq-modal-spec-label">' + label + '</div><div class="aq-modal-spec-value">' + esc(value) + '</div></div>';
                };
                var featuresHtml = product.features.map(function (f) {
                    return '<li><span>✓</span> ' + esc(f) + '</li>';
                }).join('');
                var startVariant = closestVariant(variantsForPack(product, defaultPack(product)), 1);

                modalBody.innerHTML =
                    '<div class="aq-modal-block">' +
                        '<h4 class="aq-modal-block-title">Specifications</h4>' +
                        '<div class="aq-modal-spec-grid">' +
                            specBox('Conductor', product.conductor) +
                            specBox('Geometry', product.geometry) +
                            specBox('Noise-Dissipation', product.noise) +
                            specBox('Terminations', product.terminations) +
                        '</div>' +
                    '</div>' +
                    (featuresHtml
                        ? '<div class="aq-modal-block"><h4 class="aq-modal-block-title">Features</h4><ul class="aq-modal-feature-list">' + featuresHtml + '</ul></div>'
                        : '') +
                    '<div class="aq-modal-block">' +
                        '<h4 class="aq-modal-block-title">Choose Your Length</h4>' +
                        variantPickerHtml(product, startVariant) +
                    '</div>';

                var vp = modalBody.querySelector('[data-aq-vp]');
                if (vp) updateVariantPicker(vp);
            }

            modal.classList.add('active');
        }

        function closeModal() {
            if (modal) modal.classList.remove('active');
        }

        /* ── Cable Finder ── */

        function finderPool() {
            return products.filter(function (c) {
                return c.inFinder !== false && c.type === answers.q1 && c.variants.length;
            });
        }

        function scrollToFinder() {
            if (!finder) return;
            var rect = finder.getBoundingClientRect();
            if (rect.top < 0 || rect.top > window.innerHeight * 0.4) {
                window.scrollTo({ top: window.pageYOffset + rect.top - 100, behavior: 'smooth' });
            }
        }

        function updateProgress(done) {
            if (finderFill) finderFill.style.width = (done ? 100 : ((currentStep - 1) / TOTAL_STEPS) * 100) + '%';
            finderDots.forEach(function (dot) {
                var s = parseInt(dot.getAttribute('data-aq-finder-dot'), 10);
                dot.classList.remove('active', 'done');
                if (done || s < currentStep) dot.classList.add('done');
                else if (s === currentStep) dot.classList.add('active');
            });
            if (finderBack) finderBack.hidden = done || currentStep === 1;
        }

        // Hide run lengths shorter than anything this cable type comes in (e.g. subwoofer
        // cables start at 2 m) — a shorter run just gets the shortest cable anyway.
        function updateLengthOptions() {
            var pool = finderPool();
            var minAvail = pool.length ? Math.min.apply(null, pool.map(function (p) { return p.minLength; })) : 0;
            var maxAvail = pool.length ? Math.max.apply(null, pool.map(function (p) { return p.maxLength; })) : Infinity;
            var cards = root.querySelectorAll('[data-aq-finder-step="4"] .aq-finder-card');
            var firstVisible = null;
            cards.forEach(function (card) {
                var m = parseFloat(card.getAttribute('data-val'));
                var show = m >= minAvail - 0.001 && m <= maxAvail + 0.001;
                card.hidden = !show;
                if (show && !firstVisible) firstVisible = card;
            });
            // The shortest visible option reads "Up to X m".
            cards.forEach(function (card) {
                var title = card.querySelector('.aq-finder-card-title');
                if (!title) return;
                var m = card.getAttribute('data-val');
                title.textContent = (card === firstVisible ? 'Up to ' : '') + m + ' m';
            });
        }

        function goToStep(n) {
            currentStep = n;
            if (n === 4) updateLengthOptions();
            root.querySelectorAll('[data-aq-finder-step]').forEach(function (step) {
                step.classList.toggle('active', parseInt(step.getAttribute('data-aq-finder-step'), 10) === n);
            });
            updateProgress(false);
            scrollToFinder();
        }

        function byTierCloseness(idealTier) {
            return function (a, b) {
                var dA = Math.abs(a.product.rank - idealTier);
                var dB = Math.abs(b.product.rank - idealTier);
                if (dA !== dB) return dA - dB;
                return b.product.rank - a.product.rank;
            };
        }

        // Returns { mode, picks: [{ product, variant }] }.
        //   match      — cables that cover the run AND whose price at that length fits the budget,
        //                ranked by closeness to the system level (original WordPress ranking).
        //   overBudget — nothing fits the budget at this length: the cheapest cables that cover it.
        //   tooLong    — nothing is made that long: the longest cables available.
        function recommend() {
            var budgetKey = answers.q3 || 'budget2';
            var needed = parseFloat(answers.q4) || 1;
            var idealTier = SYSTEM_TIER[answers.q2 || 'mid'];

            var candidates = finderPool().map(function (p) {
                return { product: p, variant: variantForRun(p, needed) };
            });

            var covering = candidates.filter(function (c) { return c.variant; });
            var inBudget = covering.filter(function (c) { return fitsBudget(c.variant.price, budgetKey); });

            if (inBudget.length) {
                inBudget.sort(byTierCloseness(idealTier));
                return { mode: 'match', picks: inBudget.slice(0, 2) };
            }

            if (covering.length) {
                covering.sort(function (a, b) { return a.variant.price - b.variant.price; });
                return { mode: 'overBudget', picks: covering.slice(0, 2) };
            }

            var longest = candidates.map(function (c) {
                return { product: c.product, variant: longestVariant(c.product) };
            }).filter(function (c) { return c.variant; });
            longest.sort(function (a, b) {
                return (b.variant.meters - a.variant.meters) || byTierCloseness(idealTier)(a, b);
            });
            return { mode: 'tooLong', picks: longest.slice(0, 2) };
        }

        function showResults() {
            var type = answers.q1 || 'interconnect';
            var sysLevel = answers.q2 || 'mid';
            var budgetKey = answers.q3 || 'budget2';
            var needed = parseFloat(answers.q4) || 1;
            var result = recommend();

            if (finderSummary) {
                finderSummary.textContent = [
                    TYPE_LABEL[type],
                    SYSTEM_LABEL[sysLevel] + ' system',
                    'budget ' + BUDGET_LABEL[budgetKey],
                    'run of ' + metersLabel(needed)
                ].join(' · ');
            }

            if (finderNotice) {
                var notice = '';
                if (result.mode === 'overBudget') {
                    notice = 'No ' + TYPE_LABEL[type].toLowerCase() + ' fits a ' + BUDGET_LABEL[budgetKey] + ' budget at ' + metersLabel(needed) + '. Here are the most affordable options at that length.';
                } else if (result.mode === 'tooLong') {
                    notice = 'No ' + TYPE_LABEL[type].toLowerCase() + ' is made in ' + metersLabel(needed) + '. Here are the longest options available — contact us for help with longer runs.';
                }
                finderNotice.textContent = notice;
                finderNotice.hidden = !notice;
            }

            if (finderResultsGrid) {
                if (!result.picks.length) {
                    finderResultsGrid.innerHTML = '<p class="aq-empty-note">No cables of this type are set up for the finder yet.</p>';
                } else {
                    finderResultsGrid.innerHTML = result.picks.map(function (pick, idx) {
                        var cable = pick.product;
                        var variant = pick.variant;
                        var isPrimary = idx === 0 && result.mode === 'match';
                        var badge = result.mode === 'match'
                            ? (idx === 0 ? 'Best Match' : 'Also Consider')
                            : (result.mode === 'overBudget' ? (idx === 0 ? 'Lowest Price' : 'Next Option') : 'Longest Available');
                        var whyText = cable.why && cable.why[sysLevel] ? cable.why[sysLevel] : '';
                        var specs = [
                            cable.conductor,
                            cable.geometry ? cable.geometry + ' Geometry' : '',
                            cable.noise,
                            cable.terminations
                        ].filter(Boolean).map(function (s) { return '<li>' + esc(s) + '</li>'; }).join('');
                        var withinBudget = fitsBudget(variant.price, budgetKey);
                        var priceLine =
                            '<strong>' + money(variant.price) + '</strong> for ' + metersLabel(variant.meters) +
                            (variant.pack ? ' ' + esc(variant.pack.toLowerCase()) : '') +
                            '<span class="aq-finder-budget-tag' + (withinBudget ? ' is-within' : ' is-over') + '">' +
                                (withinBudget ? 'Within budget' : 'Above budget') +
                            '</span>';

                        return (
                            '<div class="aq-finder-result-card' + (isPrimary ? ' primary' : '') + '">' +
                                '<span class="aq-finder-result-badge' + (isPrimary ? '' : ' alt') + '">' + badge + '</span>' +
                                '<div class="aq-finder-result-top">' +
                                    (cable.image ? '<div class="aq-finder-result-image"><img src="' + esc(cable.image) + '" alt="AudioQuest ' + esc(cable.name) + '" loading="lazy"></div>' : '') +
                                    '<div>' +
                                        '<div class="aq-finder-result-name">AudioQuest ' + esc(cable.name) + '</div>' +
                                        '<div class="aq-finder-result-from">' + priceLine + '</div>' +
                                    '</div>' +
                                '</div>' +
                                '<ul class="aq-finder-result-specs">' + specs + '</ul>' +
                                (whyText ? '<p class="aq-finder-result-why">' + esc(whyText) + '</p>' : '') +
                                variantPickerHtml(cable, variant) +
                            '</div>'
                        );
                    }).join('');

                    finderResultsGrid.querySelectorAll('[data-aq-vp]').forEach(updateVariantPicker);
                }
            }

            updateProgress(true);
            if (finderBody) finderBody.hidden = true;
            if (finderResults) finderResults.hidden = false;
            scrollToFinder();
        }

        function resetFinder() {
            answers = {};
            root.querySelectorAll('.aq-finder-card').forEach(function (c) { c.classList.remove('selected'); });
            if (finderResults) finderResults.hidden = true;
            if (finderBody) finderBody.hidden = false;
            goToStep(1);
        }

        /* ── Events ── */

        function setupEventListeners() {
            typeBtns.forEach(function (btn) {
                btn.addEventListener('click', function () {
                    gridType = btn.dataset.aqTypeBtn;
                    gridTier = 'all';
                    typeBtns.forEach(function (b) {
                        var on = b === btn;
                        b.classList.toggle('active', on);
                        b.setAttribute('aria-selected', on ? 'true' : 'false');
                    });
                    updateTierButtons();
                    renderProducts();
                });
            });

            tierBtns.forEach(function (btn) {
                btn.addEventListener('click', function () {
                    gridTier = btn.dataset.aqTierBtn;
                    updateTierButtons();
                    renderProducts();
                });
            });

            root.addEventListener('click', function (e) {
                var card = e.target.closest('.aq-finder-card');
                if (card) {
                    var q = card.getAttribute('data-q');
                    answers['q' + q] = card.getAttribute('data-val');
                    card.closest('.aq-finder-grid').querySelectorAll('.aq-finder-card').forEach(function (c) {
                        c.classList.toggle('selected', c === card);
                    });
                    setTimeout(function () {
                        if (currentStep < TOTAL_STEPS) goToStep(currentStep + 1);
                        else showResults();
                    }, 280);
                    return;
                }

                if (e.target.closest('[data-aq-finder-back]')) {
                    if (currentStep > 1) goToStep(currentStep - 1);
                    return;
                }

                if (e.target.closest('[data-aq-finder-restart]')) {
                    resetFinder();
                    return;
                }

                var detailsBtn = e.target.closest('[data-aq-show-details]');
                if (detailsBtn) {
                    showProductDetails(detailsBtn.getAttribute('data-aq-show-details'));
                    return;
                }
            });

            root.addEventListener('change', function (e) {
                var vp = e.target.closest('[data-aq-vp]');
                if (!vp) return;
                if (e.target.matches('[data-aq-vp-pack]')) onPackChange(vp);
                else if (e.target.matches('[data-aq-vp-length]')) updateVariantPicker(vp);
            });

            faqQuestions.forEach(function (question) {
                question.addEventListener('click', function () {
                    var isActive = question.classList.contains('active');
                    var answer = question.nextElementSibling;

                    faqQuestions.forEach(function (q) {
                        q.classList.remove('active');
                        if (q.nextElementSibling) q.nextElementSibling.style.maxHeight = '0';
                    });

                    if (!isActive && answer) {
                        question.classList.add('active');
                        answer.style.maxHeight = answer.scrollHeight + 'px';
                    }
                });
            });

            if (modalClose && modal) {
                modalClose.addEventListener('click', closeModal);
                modal.addEventListener('click', function (e) {
                    if (e.target === modal) closeModal();
                });
                document.addEventListener('keydown', function (e) {
                    if (e.key === 'Escape') closeModal();
                });
                // Close the modal once its Add to Cart fires so the cart drawer is visible.
                modal.addEventListener('submit', function () {
                    setTimeout(closeModal, 0);
                });
            }

            root.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
                anchor.addEventListener('click', function (e) {
                    var href = this.getAttribute('href');
                    if (href && href.length > 1) {
                        var target = root.querySelector(href) || document.querySelector(href);
                        if (target) {
                            e.preventDefault();
                            target.scrollIntoView({ behavior: 'smooth' });
                        }
                    }
                });
            });
        }

        function setupScrollAnimations() {
            if (!('IntersectionObserver' in window)) {
                root.querySelectorAll('.aq-fade-in').forEach(function (el) { el.classList.add('visible'); });
                return;
            }
            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) entry.target.classList.add('visible');
                });
            }, { threshold: 0.1 });

            root.querySelectorAll('.aq-fade-in').forEach(function (el) { observer.observe(el); });
        }

        // Hide the Interconnect/Subwoofer tabs if only one type has products.
        var typesPresent = [];
        products.forEach(function (p) { if (typesPresent.indexOf(p.type) === -1) typesPresent.push(p.type); });
        if (typesPresent.length === 1) {
            gridType = typesPresent[0];
            var typeSelector = root.querySelector('.aq-type-selector');
            if (typeSelector) typeSelector.hidden = true;
        }

        updateTierButtons();
        renderProducts();
        setupEventListeners();
        setupScrollAnimations();
        updateProgress(false);
    }

    function initAll() {
        document.querySelectorAll('.aq-rca').forEach(initAqRca);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
    } else {
        initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
        var section = event.target.querySelector ? event.target.querySelector('.aq-rca') : null;
        if (section) initAqRca(section);
    });
})();
